






























import { Component } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Table, TableOptions, getTableCaption } from '@/core/components/table';
import { Page } from '@/core/components/controls';
import TechesListTable from './TechesListTable.vue';

@Component({
    components: {
        TechesListTable,
        TableOptions,
    },
})
export default class OperationsListPage extends Page {
    public table: Table | null = null;
    public tableKey: string = 'operations-list-control';

    public setTable(table: Table): void {
        this.table = table;
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get isRowSelected() {
        return this.table && this.table!.getSelectedRowKeys().length === 1;
    }

    public addOperation() {
        this.table!.addRow();
    }

    public editOperation() {
        const selectedKey = this.table!.getSelectedRowKeys()[0];

        if (selectedKey) {
            const selectedIndex = this.table!.getRowIndexByKey(selectedKey);
            this.table!.editRow(selectedIndex);
        }
    }

    private deleteOperation() {
        const table = this.$refs['table-component'] as TechesListTable;
        table.deleteTech();
    }
}
